/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    /**
     * Goo.gl import popup switch domains
     */
    $('body').on('click', '[data-popup="#import-googl-popup"]', function() {
        if ($(this).data('domain')) {
            $('#import-googl-popup').find('[name=domain]').val($(this).data('domain')).trigger('change');
        }
    });
});

/**
 * make Bitly Import
 */
function makeImportBitly() {
    var token = $("#import_bitly_csrf_token").val();
    $.ajax({
        type: 'POST',
        url: "./../capsule/import/bitly_import",
        data: {
            '_token': token,
        },
        success: function (data) {
            if (data.message) {
                if (data.delay) {
                    infoWithDelay(data.message, data.delay);
                }
                else {
                    info(data.message);
                }
            }
            if (data.redirect_url) {
                window.open(data.redirect_url, '_self');
            }
        },
        error: function () {
            alert('Error');
        }
    });
}
